export default "__VITE_ASSET__c9e7f0f4__"